// extracted by mini-css-extract-plugin
export default {"chip":"Chip-module__chip--_5_xD","cta":"Chip-module__cta--HpDxi","selected":"Chip-module__selected--QQCFN"};